// GENERATED by packages/tokens/scripts/build.mjs from the brand kernel. Do not edit.
export const tokens = {
  "meta": {
    "kernelVersion": "2.0.0-boldpop",
    "kernelDate": "2026-10-05",
    "name": "PopCart"
  },
  "colour": {
    "core": {
      "volt": "#FFE500",
      "ultra": "#1B34FF",
      "ink": "#14110F",
      "cream": "#FFF6E3"
    },
    "category": {
      "fresh": "#6EDC5F",
      "grill": "#FF4F1F",
      "mart": "#7CC8FF",
      "creatorsLive": "#FF8AD8"
    },
    "functional": {
      "success": "#0A7D3E",
      "warning": "#F5A300",
      "error": "#C4161C",
      "info": "#1B34FF"
    },
    "extended": {
      "ultra300": "#8F9CFF",
      "white": "#FFFFFF"
    },
    "neutral": {
      "ink800": "#211D1A",
      "ink700": "#3A3430",
      "ink500": "#6E665C",
      "ink300": "#A39A8B",
      "cream200": "#F3EAD6",
      "disabledFill": "#E9DFC9",
      "disabledEdge": "#C9BEA8"
    }
  },
  "theme": {
    "light": {
      "bg.base": "#FFF6E3",
      "bg.raised": "#FFFFFF",
      "bg.raisedOutline": "#F3EAD6",
      "bg.sunken": "#F3EAD6",
      "text.primary": "#14110F",
      "text.secondary": "#6E665C",
      "text.link": "#1B34FF",
      "line.divider": "#F3EAD6",
      "line.control": "#6E665C",
      "focus.ring": "#1B34FF",
      "focus.edge": "#14110F",
      "action.primary.bg": "#1B34FF",
      "action.primary.fg": "#FFE500",
      "action.secondaryFill.bg": "#FFE500",
      "action.secondaryFill.fg": "#14110F",
      "action.disabled.bg": "#E9DFC9",
      "action.disabled.fg": "#A39A8B",
      "action.disabled.edge": "#C9BEA8",
      "action.primary.outline": "#14110F",
      "action.secondary.fg": "#14110F",
      "action.secondary.outline": "#14110F",
      "status.success.bg": "#0A7D3E",
      "status.success.fg": "#FFF6E3",
      "status.warning.bg": "#F5A300",
      "status.warning.fg": "#14110F",
      "status.error.bg": "#C4161C",
      "status.error.fg": "#FFF6E3",
      "status.info.bg": "#1B34FF",
      "status.info.fg": "#FFF6E3",
      "status.success.text": "#0A7D3E",
      "status.error.text": "#C4161C"
    },
    "dark": {
      "bg.base": "#14110F",
      "bg.raised": "#211D1A",
      "bg.raisedOutline": "#3A3430",
      "bg.sunken": "#211D1A",
      "text.primary": "#FFF6E3",
      "text.secondary": "#A39A8B",
      "text.link": "#8F9CFF",
      "line.divider": "#3A3430",
      "line.control": "#A39A8B",
      "focus.ring": "#8F9CFF",
      "focus.edge": "#14110F",
      "action.primary.bg": "#1B34FF",
      "action.primary.fg": "#FFE500",
      "action.secondaryFill.bg": "#FFE500",
      "action.secondaryFill.fg": "#14110F",
      "action.disabled.bg": "#E9DFC9",
      "action.disabled.fg": "#A39A8B",
      "action.disabled.edge": "#C9BEA8",
      "action.primary.outline": "#14110F",
      "action.secondary.fg": "#FFF6E3",
      "action.secondary.outline": "#FFF6E3",
      "status.success.bg": "#0A7D3E",
      "status.success.fg": "#FFF6E3",
      "status.warning.bg": "#F5A300",
      "status.warning.fg": "#14110F",
      "status.error.bg": "#C4161C",
      "status.error.fg": "#FFF6E3",
      "status.info.bg": "#1B34FF",
      "status.info.fg": "#FFF6E3"
    }
  },
  "category": {
    "fg": "#14110F",
    "fresh": "#6EDC5F",
    "grill": "#FF4F1F",
    "mart": "#7CC8FF",
    "express": "#FFE500",
    "live": "#FF8AD8",
    "creators": "#FF8AD8",
    "feed": "#FFF6E3",
    "sellers": "#1B34FF"
  },
  "type": {
    "ui": {
      "title": {
        "fontFamily": "Archivo",
        "fontSize": 28,
        "lineHeight": 34,
        "fontWeight": 800,
        "fontStretch": 112.5,
        "nativeFamily": "Archivo-W112-800"
      },
      "headline": {
        "fontFamily": "Archivo",
        "fontSize": 20,
        "lineHeight": 26,
        "fontWeight": 700,
        "fontStretch": 112.5,
        "nativeFamily": "Archivo-W112-700"
      },
      "body": {
        "fontFamily": "Archivo",
        "fontSize": 16,
        "lineHeight": 24,
        "fontWeight": 400,
        "fontStretch": 100,
        "nativeFamily": "Archivo-W100-400"
      },
      "label": {
        "fontFamily": "Archivo",
        "fontSize": 14,
        "lineHeight": 20,
        "fontWeight": 600,
        "fontStretch": 100,
        "nativeFamily": "Archivo-W100-600"
      },
      "caption": {
        "fontFamily": "Archivo",
        "fontSize": 12,
        "lineHeight": 16,
        "fontWeight": 500,
        "fontStretch": 100,
        "nativeFamily": "Archivo-W100-500"
      },
      "price": {
        "fontFamily": "Archivo",
        "fontSize": 20,
        "lineHeight": 24,
        "fontWeight": 900,
        "fontStretch": 125,
        "fontVariantNumeric": "tabular-nums",
        "nativeFamily": "Archivo-W125-900"
      },
      "button": {
        "fontFamily": "Archivo",
        "fontSize": 16,
        "lineHeight": 20,
        "fontWeight": 800,
        "fontStretch": 112.5,
        "nativeFamily": "Archivo-W112-800"
      },
      "displaySm": {
        "fontFamily": "Archivo",
        "fontSize": 20,
        "lineHeight": 21,
        "fontWeight": 900,
        "fontStretch": 125,
        "letterSpacingEm": -0.02,
        "nativeFamily": "Archivo-W125-900"
      },
      "display": {
        "fontFamily": "Archivo",
        "fontSize": 28,
        "lineHeight": 29,
        "fontWeight": 900,
        "fontStretch": 125,
        "letterSpacingEm": -0.02,
        "nativeFamily": "Archivo-W125-900"
      },
      "displayLg": {
        "fontFamily": "Archivo",
        "fontSize": 32,
        "lineHeight": 34,
        "fontWeight": 900,
        "fontStretch": 125,
        "letterSpacingEm": -0.02,
        "nativeFamily": "Archivo-W125-900"
      },
      "displayXl": {
        "fontFamily": "Archivo",
        "fontSize": 48,
        "lineHeight": 50,
        "fontWeight": 900,
        "fontStretch": 125,
        "letterSpacingEm": -0.02,
        "nativeFamily": "Archivo-W125-900"
      },
      "monoLabel": {
        "fontFamily": "IBM Plex Mono",
        "fontSize": 14,
        "lineHeight": 20,
        "fontWeight": 600,
        "fontStretch": 100,
        "nativeFamily": "IBMPlexMono-600",
        "extends": "ui.label"
      },
      "monoCaption": {
        "fontFamily": "IBM Plex Mono",
        "fontSize": 12,
        "lineHeight": 16,
        "fontWeight": 500,
        "fontStretch": 100,
        "nativeFamily": "IBMPlexMono-500",
        "extends": "ui.caption"
      }
    },
    "video": {
      "creator": {
        "fontFamily": "Archivo",
        "fontSize": 16,
        "lineHeight": 20,
        "fontWeight": 800,
        "fontStretch": 112.5,
        "nativeFamily": "Archivo-W112-800"
      },
      "caption": {
        "fontFamily": "Archivo",
        "fontSize": 15,
        "lineHeight": 21,
        "fontWeight": 500,
        "fontStretch": 100,
        "nativeFamily": "Archivo-W100-500"
      },
      "price": {
        "fontFamily": "Archivo",
        "fontSize": 22,
        "lineHeight": 24,
        "fontWeight": 900,
        "fontStretch": 112.5,
        "nativeFamily": "Archivo-W112-900"
      },
      "tag": {
        "fontFamily": "Archivo",
        "fontSize": 12,
        "lineHeight": 14,
        "fontWeight": 800,
        "fontStretch": 125,
        "textTransform": "uppercase",
        "nativeFamily": "Archivo-W125-800"
      },
      "count": {
        "fontFamily": "Archivo",
        "fontSize": 13,
        "lineHeight": 16,
        "fontWeight": 700,
        "fontStretch": 100,
        "nativeFamily": "Archivo-W100-700"
      }
    },
    "marketing": {
      "display_xxl": {
        "fontFamily": "Archivo",
        "fontSize": 320,
        "lineHeight": 269,
        "fontWeight": 900,
        "fontStretch": 125,
        "letterSpacingEm": -0.02,
        "textTransform": "uppercase",
        "nativeFamily": "Archivo-W125-900",
        "lineHeightRatio": 0.84
      },
      "display_xl": {
        "fontFamily": "Archivo",
        "fontSize": 200,
        "lineHeight": 172,
        "fontWeight": 900,
        "fontStretch": 125,
        "letterSpacingEm": -0.02,
        "textTransform": "uppercase",
        "nativeFamily": "Archivo-W125-900",
        "lineHeightRatio": 0.86
      },
      "display_l": {
        "fontFamily": "Archivo",
        "fontSize": 128,
        "lineHeight": 115,
        "fontWeight": 900,
        "fontStretch": 125,
        "letterSpacingEm": -0.015,
        "textTransform": "uppercase",
        "nativeFamily": "Archivo-W125-900",
        "lineHeightRatio": 0.9
      },
      "headline": {
        "fontFamily": "Archivo",
        "fontSize": 72,
        "lineHeight": 68,
        "fontWeight": 800,
        "fontStretch": 112.5,
        "letterSpacingEm": -0.01,
        "nativeFamily": "Archivo-W112-800",
        "lineHeightRatio": 0.95
      },
      "subhead": {
        "fontFamily": "Archivo",
        "fontSize": 40,
        "lineHeight": 44,
        "fontWeight": 700,
        "fontStretch": 112.5,
        "letterSpacingEm": 0,
        "nativeFamily": "Archivo-W112-700",
        "lineHeightRatio": 1.1
      },
      "body": {
        "fontFamily": "Archivo",
        "fontSize": 28,
        "lineHeight": 38,
        "fontWeight": 400,
        "fontStretch": 100,
        "letterSpacingEm": 0,
        "nativeFamily": "Archivo-W100-400",
        "lineHeightRatio": 1.35
      },
      "spec": {
        "fontFamily": "IBM Plex Mono",
        "fontSize": 18,
        "lineHeight": 25,
        "fontWeight": 500,
        "fontStretch": 100,
        "letterSpacingEm": 0.04,
        "nativeFamily": "IBMPlexMono-500",
        "lineHeightRatio": 1.4
      }
    }
  },
  "fonts": [
    {
      "nativeFamily": "Archivo-W100-400",
      "family": "Archivo",
      "stretch": 100,
      "weight": 400,
      "file": "Archivo-W100-400.ttf"
    },
    {
      "nativeFamily": "Archivo-W100-500",
      "family": "Archivo",
      "stretch": 100,
      "weight": 500,
      "file": "Archivo-W100-500.ttf"
    },
    {
      "nativeFamily": "Archivo-W100-600",
      "family": "Archivo",
      "stretch": 100,
      "weight": 600,
      "file": "Archivo-W100-600.ttf"
    },
    {
      "nativeFamily": "Archivo-W100-700",
      "family": "Archivo",
      "stretch": 100,
      "weight": 700,
      "file": "Archivo-W100-700.ttf"
    },
    {
      "nativeFamily": "Archivo-W112-700",
      "family": "Archivo",
      "stretch": 112.5,
      "weight": 700,
      "file": "Archivo-W112-700.ttf"
    },
    {
      "nativeFamily": "Archivo-W112-800",
      "family": "Archivo",
      "stretch": 112.5,
      "weight": 800,
      "file": "Archivo-W112-800.ttf"
    },
    {
      "nativeFamily": "Archivo-W112-900",
      "family": "Archivo",
      "stretch": 112.5,
      "weight": 900,
      "file": "Archivo-W112-900.ttf"
    },
    {
      "nativeFamily": "Archivo-W125-800",
      "family": "Archivo",
      "stretch": 125,
      "weight": 800,
      "file": "Archivo-W125-800.ttf"
    },
    {
      "nativeFamily": "Archivo-W125-900",
      "family": "Archivo",
      "stretch": 125,
      "weight": 900,
      "file": "Archivo-W125-900.ttf"
    },
    {
      "nativeFamily": "IBMPlexMono-400",
      "family": "IBM Plex Mono",
      "stretch": 100,
      "weight": 400,
      "file": "IBMPlexMono-400.ttf"
    },
    {
      "nativeFamily": "IBMPlexMono-500",
      "family": "IBM Plex Mono",
      "stretch": 100,
      "weight": 500,
      "file": "IBMPlexMono-500.ttf"
    },
    {
      "nativeFamily": "IBMPlexMono-600",
      "family": "IBM Plex Mono",
      "stretch": 100,
      "weight": 600,
      "file": "IBMPlexMono-600.ttf"
    }
  ],
  "motion": {
    "anticipate": {
      "ms": 120,
      "bezier": [
        0.6,
        0,
        0.9,
        0.4
      ]
    },
    "burst": {
      "ms": 90,
      "bezier": [
        0.1,
        0.9,
        0.2,
        1
      ]
    },
    "overshoot": {
      "ms": 140,
      "bezier": [
        0.3,
        1.6,
        0.6,
        1
      ]
    },
    "settle": {
      "ms": 220,
      "bezier": [
        0.4,
        0,
        0.2,
        1
      ]
    },
    "press": {
      "ms": 80,
      "bezier": [
        0.4,
        0,
        0.2,
        1
      ]
    },
    "spring": {
      "bezier": [
        0.3,
        1.6,
        0.6,
        1
      ]
    },
    "micro": {
      "ms": 285,
      "bezier": [
        0.3,
        1.6,
        0.6,
        1
      ]
    },
    "out": {
      "ms": 160,
      "bezier": [
        0.5,
        0,
        0.9,
        0.4
      ],
      "scale": 0.6
    },
    "reduced": {
      "ms": 150,
      "easing": "linear"
    },
    "totals": {
      "brand": 570,
      "ui": 285,
      "micro": 285
    },
    "ui": {
      "anticipate": 60,
      "burst": 45,
      "overshoot": 70,
      "settle": 110
    },
    "squash": {
      "anticipate": [
        1.12,
        0.86
      ],
      "burst": [
        0.92,
        1.1
      ],
      "overshoot": [
        1.04,
        0.97
      ],
      "press": [
        1.04,
        0.94
      ]
    }
  },
  "radius": {
    "container": 28,
    "chip": 16,
    "loud": 0,
    "pill": 999
  },
  "scrim": {
    "colour": "#000000",
    "fromOpacity": 0,
    "toOpacity": 0.6,
    "coverage": 0.38,
    "source": "Scrim: linear 0% → 60% black, bottom 38% of frame; the only permitted gradient."
  },
  "radiiRaw": {
    "none": 0,
    "sm": 16,
    "md": 28,
    "lg": 28,
    "pill": 999,
    "rule": "Cards 28, chips 16, buttons and badges full pills (§14)."
  },
  "bannedRadii": [],
  "elevation": {
    "lift": {
      "rest": 6,
      "hover": 9,
      "pressed": 0
    },
    "sticker": {
      "offset": 10,
      "border": 6
    },
    "press": {
      "squashX": 1.04,
      "squashY": 0.94
    }
  },
  "space": {
    "4": 4,
    "8": 8,
    "12": 12,
    "16": 16,
    "24": 24,
    "32": 32,
    "48": 48,
    "64": 64,
    "96": 96,
    "128": 128,
    "192": 192
  },
  "grid": {
    "slide": {
      "size": "1920x1080",
      "columns": 12,
      "margin": 96,
      "gutter": 24
    },
    "mobile": {
      "ref": "390pt",
      "columns": 4,
      "margin": 16,
      "gutter": 12
    },
    "feed": {
      "ref": "1080x1920",
      "margin": 48
    }
  },
  "stroke": {
    "ui": 3,
    "onVideoText": 3
  },
  "modes": {
    "loud": {
      "use": [
        "marketing",
        "packaging",
        "riders",
        "out-of-home",
        "brand moments"
      ],
      "proportion": {
        "volt": 60,
        "ultra": 25,
        "cream": 10,
        "ink": 5
      },
      "rules": [
        "Full-bleed signature colour.",
        "Display type ExtraExpanded 900, may crop off the edge.",
        "Pop shapes and illustration allowed.",
        "Full pop motion (500 ms)."
      ]
    },
    "stage": {
      "use": [
        "feed",
        "live",
        "creator content",
        "seller content",
        "product UI"
      ],
      "proportion": {
        "content": 70,
        "volt": 12,
        "ultra": 8,
        "ink": 6,
        "cream": 4
      },
      "signals": [
        "pop stickers (NEW, -30%, LIVE, price)",
        "category-colour tiles and chips",
        "3px Ink edge + 6px lift on everything pressable",
        "the pop on arrival"
      ],
      "legibility": [
        "Solid surfaces (Night Ink / Day Cream) for controls and cards.",
        "Text on video: Day Cream with 2px Night Ink outline.",
        "Scrim: linear 0% → 60% black, bottom 38% of frame; the only permitted gradient."
      ],
      "safeZones": {
        "ref": "1080x1920",
        "topBar": [
          132,
          264
        ],
        "rightRail": {
          "x": [
            924,
            1032
          ],
          "y": [
            760,
            1520
          ]
        },
        "info": {
          "x": [
            48,
            900
          ],
          "y": [
            1300,
            1672
          ]
        },
        "nav": [
          1720,
          1920
        ],
        "marginX": 48
      },
      "motion": "UI pop 330 ms; micro 220 ms."
    }
  },
  "architecture": {
    "master": "PopCart",
    "deliver": {
      "Fresh": "fresh",
      "Grill": "grill",
      "Mart": "mart",
      "Express": "volt"
    },
    "discover": {
      "Feed": "cream",
      "Live": "creatorsLive",
      "Creators": "creatorsLive",
      "Sellers": "ultra"
    },
    "partners": {
      "Rider": "ultra",
      "Community": "volt"
    },
    "rules": [
      "Masterbrand first: \"PopCart Fresh\".",
      "One plain English word per descriptor; never translated in the lockup.",
      "Category colour belongs to the descriptor; the mark stays core.",
      "\"Pop\" is a verb for moments, never a product prefix.",
      "Eight descriptors maximum.",
      "Partners and people (PopCart Rider, PopCart Community) follow the same lockup and sit outside the eight."
    ]
  },
  "mark": {
    "viewBox": "0 0 120 120",
    "path": {
      "body": "M97.33 50.34A48 48 0 1 1 69.66 22.67A20 20 0 0 0 97.33 50.34Z",
      "pop": "M91.41 16.59A12 12 0 1 0 115.41 16.59A12 12 0 1 0 91.41 16.59Z"
    },
    "minSize": {
      "digitalPx": 16,
      "printMm": 5,
      "onVideoPx": 40,
      "onVideoTreatment": "always on a solid Night Ink disc chip, chip = 1.4 x mark"
    },
    "clearSpace": "X on all sides, where X = bite diameter (5u = 1/3 of the artboard)",
    "appIcon": "App icons: the mark as big as the launcher allows, its enclosing circle at 86% of the tile and centred (Android adaptive: 64 dp of the 66 dp safe circle). Customer: Pop Yellow field, Cart Blue mark. Rider: the §10 helmet wearing the §16 pop decal (the untouched mark in Cart Blue) on a Cart Blue field (§06, owner revision 2026-10-10)",
    "appIconSpec": {
      "fill": 0.86,
      "adaptiveDp": 64
    },
    "riderIcon": {
      "viewBox": "4 4 112 112",
      "shell": {
        "cx": 54,
        "cy": 64,
        "r": 44
      },
      "visor": "M80 54H104A12 12 0 0 1 104 78H80A12 12 0 0 1 80 54Z",
      "pop": {
        "cx": 95,
        "cy": 22,
        "r": 8
      },
      "decal": {
        "x": 14,
        "y": 42,
        "size": 46
      },
      "line": 2.4,
      "field": "ultra",
      "shellFill": "volt",
      "visorFill": "ink",
      "decalFill": "ultra"
    },
    "construction": {
      "body": {
        "cx": 52.5,
        "cy": 67.5,
        "r": 48,
        "diameterU": 12
      },
      "bite": {
        "cx": 86.44,
        "cy": 33.56,
        "r": 20,
        "diameterU": 5,
        "rule": "centre on the body edge at 45°"
      },
      "pop": {
        "cx": 103.41,
        "cy": 16.59,
        "r": 12,
        "diameterU": 3,
        "rule": "centre 9u from body centre on the same 45° axis"
      },
      "ratio": "12 : 5 : 3",
      "meaning": [
        "A full circle: your order, complete.",
        "A bite: something just happened.",
        "A pop: here it comes."
      ]
    }
  },
  "wordmark": {
    "name": "popcart",
    "viewBox": "-6 -50 1012 256",
    "xHeight": 134,
    "strokeWidth": 34,
    "strokeLinecap": "butt",
    "fill": "none",
    "path": {
      "strokes": [
        "M17 0V200M17 67a60 50 0 1 0 120 0a60 50 0 1 0 -120 0",
        "M343 0V200M343 67a60 50 0 1 0 120 0a60 50 0 1 0 -120 0",
        "M610.28 36.22A60 50 0 1 0 610.28 97.78",
        "M647 67a60 50 0 1 0 120 0a60 50 0 1 0 -120 0M767 0V134",
        "M813 134V67A60 50 0 0 1 873 17H902",
        "M914 17H998M944 -40V134"
      ],
      "oMark": {
        "transform": "translate(153.72 -27.22) scale(1.39583)",
        "body": "M97.33 50.34A48 48 0 1 1 69.66 22.67A20 20 0 0 0 97.33 50.34Z",
        "pop": "M91.41 16.59A12 12 0 1 0 115.41 16.59A12 12 0 1 0 91.41 16.59Z"
      }
    },
    "quirk": "The o is the Pop Mark: solid, bitten, popping. Its body diameter equals the x-height.",
    "minSize": {
      "digitalPx": 72,
      "printMm": 18
    }
  },
  "lockup": {
    "horizontal": {
      "viewBox": "-322 -60 1328 266",
      "markTransform": "translate(-320 -62.4) scale(1.9167)"
    },
    "stacked": {
      "viewBox": "-6 -510 1012 716",
      "markTransform": "translate(316.25 -514.25) scale(3.5)"
    },
    "note": "Horizontal: mark (120 grid) at x1.9167, body centred on the x-height (y 67), wordmark follows. Stacked: mark at x3.5 centred over the wordmark. The wordmark o is always the Pop Mark, in lockups too.",
    "minSize": {
      "digitalPx": 96,
      "printMm": 24
    }
  },
  "sound": {
    "name": "bl-OOP!",
    "durationMs": 450,
    "parts": [
      {
        "t": 0,
        "ms": 40,
        "note": "G5 784 Hz"
      },
      {
        "t": 40,
        "ms": 40,
        "note": "D6 1175 Hz, perfect fifth up"
      },
      {
        "t": 120,
        "ms": 90,
        "sound": "dry cork pop on the burst frame, decaying to 450 ms"
      }
    ],
    "plays": [
      "order arrival",
      "app open"
    ],
    "source": "§12"
  },
  "rules": {
    "textOnVolt": [
      "#14110F",
      "#1B34FF"
    ],
    "voltPerStageScreen": 1,
    "gradients": "scrim-only",
    "colourRules": [
      "Pop Yellow leads (≈60%), Cart Blue supports (≈25%); categories colour their own tiles and chips.",
      "Text on Pop Yellow is Ink or Cart Blue. Text on Cart Blue is Cream or White. Text on category colours is Ink.",
      "No yellow on cream (§19). No gradients, glows or soft shadows (§19).",
      "Everything you can press has a 3px Ink edge and a 6px lift (§14).",
      "Primary button: Cart Blue with a Pop Yellow label. Secondary: Pop Yellow with an Ink label (§14)."
    ]
  }
};
export default tokens;
export const meta = tokens.meta;
export const colour = tokens.colour;
export const theme = tokens.theme;
export const category = tokens.category;
export const type = tokens.type;
export const fonts = tokens.fonts;
export const motion = tokens.motion;
export const radius = tokens.radius;
export const scrim = tokens.scrim;
export const radiiRaw = tokens.radiiRaw;
export const bannedRadii = tokens.bannedRadii;
export const elevation = tokens.elevation;
export const space = tokens.space;
export const grid = tokens.grid;
export const stroke = tokens.stroke;
export const modes = tokens.modes;
export const architecture = tokens.architecture;
export const mark = tokens.mark;
export const wordmark = tokens.wordmark;
export const lockup = tokens.lockup;
export const sound = tokens.sound;
export const rules = tokens.rules;
